import type { Reading } from '@casa/driver-sdk';

/** The number a tile shows from a source's readings: the last reading, as the legacy app took it. */
export function lastNumber(readings: Reading[] | null | undefined) : number | null {
    const value = readings?.at(-1)?.value;
    if (typeof value === 'number') {
        return Number.isFinite(value) ? value : null;
    }
    if (typeof value === 'string' && value.trim() !== '') {
        const number = Number(value);

        return Number.isFinite(number) ? number : null;
    }

    return null;
}

/** The value a tile shows as it is (a status, a mode): the last reading's, a text, a number or on and off. */
export function lastValue(readings: Reading[] | null | undefined) : unknown {
    const value = readings?.at(-1)?.value;
    return value === undefined || (typeof value === 'number' && !Number.isFinite(value)) ? null : value;
}

/** The readings with a time and a finite number, as points to draw over time (a graph's series, a sparkline). */
export function readingPoints(readings: Reading[] | null | undefined) : { time: number; value: number }[] {
    const result: { time: number; value: number }[] = [];
    for (const reading of readings ?? []) {
        if (typeof reading.time === 'number' && typeof reading.value === 'number' && Number.isFinite(reading.value)) {
            result.push({ time: reading.time, value: reading.value });
        }
    }

    return result;
}
